import abu93 from "../assets/img/keys/active/abu-93-blank.png";
import abu93_back from "../assets/img/keys/active/abu-93-blank-back.png";
import abu17d from "../assets/img/keys/active/profile-abu17d.png";
import abu17d_back from "../assets/img/keys/active/profile-abu17d-back.png";
import abu86d from "../assets/img/keys/active/profile-abu86d.png";
import abu86d_back from "../assets/img/keys/active/profile-abu86d-back.png";
import bk7d from "../assets/img/keys/active/profile-bk7d.png";
import bk7d_back from "../assets/img/keys/active/profile-bk7d-back.png";
import bur23 from "../assets/img/keys/active/BUR-23.png";
import bur23_back from "../assets/img/keys/active/BUR-23-back.png";
import ce53d from "../assets/img/keys/active/profile-ce53d.png";
import ce53d_back from "../assets/img/keys/active/profile-ce53d-back.png";
import dom21 from "../assets/img/keys/active/DOM-21.png";
import dom21_back from "../assets/img/keys/active/DOM-21-back.png";
import haf2d from "../assets/img/keys/active/HAF-2D.png";
import haf2d_back from "../assets/img/keys/active/HAF-2D-back.png";
import is15 from "../assets/img/keys/active/IS-15.png";
import is15_back from "../assets/img/keys/active/IS-15-back.png";
import jng1d from "../assets/img/keys/active/JNG-1D.png";
import jng1d_back from "../assets/img/keys/active/JNG-1D-back.png";
import re6d from "../assets/img/keys/active/RE-6D.png";
import re6d_back from "../assets/img/keys/active/RE-6D-back.png";
import u15d from "../assets/img/keys/active/U-15D.png";
import u15d_back from "../assets/img/keys/active/U-15D-back.png";
import wil66d from "../assets/img/keys/active/profile-wil66d.png";
import wil66d_back from "../assets/img/keys/active/profile-wil66d-back.png";
import win22 from "../assets/img/keys/active/profile-win22.png";
import win22_back from "../assets/img/keys/active/profile-win22-back.png";

type IKeyOriginalImages = {
  [name: string]: {
    front: string;
    back: string;
  };
};

export const ORIGINAL_KEY_IMAGES: IKeyOriginalImages = {
  "abu-17d": {
    front: abu17d,
    back: abu17d_back,
  },
  "abu-86d": {
    front: abu86d,
    back: abu86d_back,
  },
  "abu-93": {
    front: abu93,
    back: abu93_back,
  },
  "bk-7d": {
    front: bk7d,
    back: bk7d_back,
  },
  "bur-23": {
    front: bur23,
    back: bur23_back,
  },
  "ce-53d": {
    front: ce53d,
    back: ce53d_back,
  },
  "dom-21": {
    front: dom21,
    back: dom21_back,
  },
  "haf-2d": {
    front: haf2d,
    back: haf2d_back,
  },
  "is-15": {
    front: is15,
    back: is15_back,
  },
  "jng-1d": {
    front: jng1d,
    back: jng1d_back,
  },
  "re-6d": {
    front: re6d,
    back: re6d_back,
  },
  "u-15d": {
    front: u15d,
    back: u15d_back,
  },
  "wil-66d": {
    front: wil66d,
    back: wil66d_back,
  },
  "win-22": {
    front: win22,
    back: win22_back,
  },
};
